import {
  dateType,
  stringType,
  numberType,
  booleanType,
  arrayType,
  optionalType,
} from '../internal';

export const types = {
  date: dateType,
  string: stringType,
  number: numberType,
  boolean: booleanType,
  array: arrayType,
  optional: optionalType,
};
